import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportItemLedgerService extends GenericService {
    constructor() {
        super('/reports/item_ledger', axiosInstance);
    }
}

export default new ReportItemLedgerService(); 